import { createContext } from 'react';

// Provides the DOM node into which the Admin portal renders. Set in
// index.js (the parallel `#admin-root` div); consumed by the Admin route
// component to escape the default Layout's centred `<Container>`.
export const AdminPortalContext = createContext(null);
